import React, { Component } from 'react';
import { Table, FormGroup, ControlLabel, FormControl, HelpBlock, Button, Col } from 'react-bootstrap';
import firebase from '../helpers/firebase';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import moment from 'moment';
import UserCombobox from './UserCombobox';
import { connect } from 'react-redux';
import { TABLE_NAME } from '../helpers/constants';

const db = firebase.database();

class FormUpto extends Component {
  constructor(props) {
    super(props);

    this.state = {
      date: moment().format('YYYY-MM-DD'),
      absenceType: 't',
      absenceCount: { t: 0, et: 0, awol: 0 }
    }

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSelectedUserChange = this.handleSelectedUserChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {

    const { user } = this.props

    if (!(user.level && user.level === 'admin')) {
      window.location.href = '/dashboard';
      return true;
    }
    this.admin = user;
  }

  getAbsences(selectedUserId) {
    console.log('id ' + selectedUserId);
    db.ref(TABLE_NAME.ABSENCES)
      .orderByChild('userId')
      .equalTo(selectedUserId)
      .once('value').then((snapshots) => {

        var absenceCount = {t: 0, et: 0, awol: 0};
        snapshots.forEach((snapshot) => {
          const absence = snapshot.val();
          if (absence.type === 'awol' || moment().diff(moment(absence.date), 'days') <= 90) {
            absenceCount[absence.type] += 1;
          }
        });
        this.setState({absenceCount});
        console.log(JSON.stringify(absenceCount));
      });
  }

  handleInputChange(e) {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({
      [name]: value}
    );
  }

  handleSelectedUserChange(newSelectedUserId) {
    this.setState({
      selectedUserId: newSelectedUserId
    });
    this.getAbsences(newSelectedUserId);
  }

  handleDateChange(date, modifiers) {
    this.setState({date: date.format('YYYY-MM-DD')});
  }

  handleSubmit() {
    const data = {
      date: this.state.date,
      userId: this.state.selectedUserId,
      type: this.state.absenceType
    };

    db.ref(TABLE_NAME.ABSENCES).push(data).then(() => {
      window.location.href = '/admin';
    });
  }

  render() {

    const userCombobox = (
      <UserCombobox
        onInputChange={this.handleSelectedUserChange}
        selectedUserId={this.state.selectedUserId}>
      </UserCombobox>
    );

    if (!this.state.selectedUserId) {
      return (
        <form>
          <Col xs={12} md={6}>
            {userCombobox}
          </Col>
        </form>
      );
    }

    const dayPickerProps = {
      todayButton: 'Go to Today',
      enableOutsideDays: true,
      modifiers: {
        monday: { daysOfWeek: [1] },
      },
      disabledDays: {
        after: new Date()
      }
    };

    let isLoading = this.state.isLoading;

    return (
      <form>
        <Col xs={12} md={6}>
          {userCombobox}

          <FormGroup controlId="date">
            <ControlLabel>Happen Date</ControlLabel>

            <DayPickerInput
              value={this.state.date}
              className="form-control date"
              onDayChange={(date, modifiers) => this.handleDateChange(date, modifiers)}
              name="date"
              id="date"
              format="YYYY-MM-DD"
              dayPickerProps={dayPickerProps}
            />
            <HelpBlock>
              The date the guy is tardiness or AWOL
            </HelpBlock>
          </FormGroup>

          <FormGroup controlId="upto-type">
            <ControlLabel>Unpaid Timeoff type:</ControlLabel>
            <FormControl id="upto-type"
              name="absenceType"
              onChange={this.handleInputChange}
              componentClass="select"
              placeholder="select"
              value={this.state.absenceType}>
              <option defaultValue value="t">Tardiness</option>
              <option value="et">Extreme Tardiness</option>
              <option value="awol">AWOL</option>
            </FormControl>
          </FormGroup>
          <Button type="submit"
            bsStyle="success"
            disabled={isLoading}
            onClick={!isLoading ? this.handleSubmit : null}
          >
            {isLoading ? 'Submitting...' : 'Submit'}
          </Button>

        </Col>
        <Col xs={12} md={6} >
          <AbsenceBalanceTable absenceCount={this.state.absenceCount}/>
        </Col>

      </form>
    );
  }
}

function AbsenceBalanceTable(props) {

  return (<Table striped bordered condensed hover>
    <thead>
      <tr>
        <th>Type</th>
        <th>Absence Count</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>Tardiness in 3 months</td>
        <td>{props.absenceCount.t}</td>
      </tr>
      <tr>
        <td>Extreme Tardiness in 3 months</td>
        <td>{props.absenceCount.et}</td>
      </tr>
      <tr>
        <td>AWOL</td>
        <td>{props.absenceCount.awol}</td>
      </tr>

    </tbody>
  </Table>);

}

const mapStateToProps = (state) => {
  const { user } = state.auth;
  return { user };
}

export default connect(mapStateToProps)(FormUpto);



// WEBPACK FOOTER //
// ./src/components/FormAbsence.js